import React, { useEffect } from 'react';
import './About.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import missionImg from '../assets/Project/project_5.png';
import {  Pagination, FreeMode, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import Aos from 'aos';

const About = () => {

  useEffect(() => {
      // Force window to scroll to the very top instantly when the component mounts
      window.scrollTo(0, 0);
      Aos.init({ duration: 1000, once: true });
    }, []);

  // const tabContent = {
  //   construction: {
  //     title: "Expert Quality in Construction",
  //     subtitle: "We provide the best services ensuring your outstanding growth through durable, high-quality structures.",
  //     points: [
  //       "Outstanding Performance", "Strategy Meets Technology", 
  //       "Global Support Network", "Exceptional Communication", 
  //       "Rapid Talent Acquisition", "24/7 Availability Across Time"
  //     ],
  //   },
  //   process: {
  //     title: "Efficient Work Process",
  //     subtitle: "A streamlined construction workflow following industry standard safe protocols.",
  //     points: [
  //       "Detailed Planning", "Transparent Costs", 
  //       "Regular Inspections", "Progress Reporting", 
  //       "Risk Management", "Smooth Handover"
  //     ],
  //   },
  //   safety: {
  //     title: "Safety & Trust",
  //     subtitle: "Building with responsibility, safety compliance, and long-term client trust.",
  //     points: [
  //       "Safety Protocols", "Certified Equipment", 
  //       "Compliance Standards", "Insured Workforce", 
  //       "Zero-Tolerance Policy", "Reliability"
  //     ],
  //   },
  // };

 const historyData = [
    { years: "2019", title: "Formed", position: "bottom", active: true },
    { years: "2020", title: "Completed 4 Projects", position: "top", active: false },
    { years: "2021", title: "Completed 6 Projects", position: "bottom", active: false },
    { years: "2022", title: "Completed 3 Projects", position: "top", active: true },
    { years: "2023", title: "Completed 5 Projects", position: "bottom", active: false },
    { years: "2024", title: "Completed 3 Projects", position: "top", active: true },
    { years: "2025", title: "Completed 3 Projects", position: "bottom", active: false },
    { years: "2026", title: "Ongoing 3 projects", position: "top", active: true },
  ];

  return (
    <div className="services-page">
      {/* HERO SECTION */}
      <section className="services-hero-container">
        <div className="hero-overlay">
          <div className="container text-center">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-center">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active text-white" aria-current="page">About Us</li>
              </ol>
            </nav>
            <h1 className="display-3 fw-bold text-white">About Us</h1>
            <div className="yellow-divider mx-auto my-3"></div>
            <p className="lead text-light mt-3 mx-auto" style={{ maxWidth: '800px' }}>
              Construction is the process of planning, designing, and building infrastructure such as residential homes, commercial and industrial facilities.
            </p>
          </div>
        </div>
      </section>
      <section className="mission-section py-5 bg-white">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-6" data-aos="fade-right">
              <h6 className="text-uppercase text-muted fw-bold">Our Mission</h6>
              <h2 className="display-5 fw-bold mb-4">Mission-Driven Results</h2>
              <p className="text-muted mb-4">Our mission to build dream spaces with quality, integrity,
transparency and sustainability in concurrence with modernised ideas
by utilising BIM technology. We believe that the construction process
benefits our clients by having a team with professional approach.</p>
              <div className="row g-3 mb-5">
                <div className="col-sm-6"><i className="bi bi-check-circle-fill text-yellow me-2"></i> Customized Strategy</div>
                <div className="col-sm-6"><i className="bi bi-check-circle-fill text-yellow me-2"></i> Industry Insights</div>
                <div className="col-sm-6"><i className="bi bi-check-circle-fill text-yellow me-2"></i> Startup & Enterprise Support</div>
                <div className="col-sm-6"><i className="bi bi-check-circle-fill text-yellow me-2"></i> Global Expansion Planning</div>
              </div>
              <h1 className="mission-text-outline">MISSION</h1>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <h3 className="fw-bold">Achieve goals</h3>
              <p className="text-muted">We aim to help businesses achieve sustainable growth through effective strategies.</p>
              
              <div className="skill-item mb-4">
                <div className="d-flex justify-content-between mb-2">
                  <span className="fw-bold">Core Construction</span>
                  <span>88%</span>
                </div>
                <div className="progress rounded-pill" style={{ height: '8px' }}>
                  <div className="progress-bar bg-dark" style={{ width: '88%' }}></div>
                </div>
              </div>

              <div className="skill-item mb-5">
                <div className="d-flex justify-content-between mb-2">
                  <span className="fw-bold">Technical & Trade</span>
                  <span>95%</span>
                </div>
                <div className="progress rounded-pill" style={{ height: '8px' }}>
                  <div className="progress-bar bg-dark" style={{ width: '95%' }}></div>
                </div>
              </div>
              <img src={missionImg} alt="Mission" className="img-fluid rounded-3" />
            </div>
          </div>
        </div>
      </section>

     

      {/* ROADMAP SECTION */}
      {/* ROADMAP SECTION */}
<section className="roadmap-section py-5">
  <div className="container-fluid px-0"> 
    <div className="text-center mb-5">
      <span className="section-subtitle">OUR COMPANY ROADMAP</span>
      <h2 className="section-title text-white"><span className="text-yellow">VPS INFRASTRUCTURE</span>  Construction History</h2>
      <p className="text-white-50 mx-auto" style={{ maxWidth: '600px' }}>
        We believe that every business is unique; our approach is never growth.
      </p>
      <p className="section-title text-yellow mx-auto">Till now completed 33 renovation works</p>
      <p className="section-title text-yellow mx-auto">Ongoing Government 4 projects</p>
    </div>

    <div className="roadmap-container">
      <div className="timeline-line-full"></div>

      <Swiper
        /* Removed Navigation from modules */
        modules={[Pagination, FreeMode, Mousewheel]} 
        grabCursor={true}
        freeMode={true}
        mousewheel={true}
        slidesPerView={1}
        /* Navigation set to false to remove side arrows */
        navigation={false} 
        breakpoints={{
          640: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
          1600: { slidesPerView: 5 },
        }}
        className="roadmap-swiper"
      >
        {historyData.map((item, index) => (
          <SwiperSlide key={index}>
            <div className={`roadmap-item ${item.position}`}>
              {item.position === 'top' && (
                <div className="history-card top-card">
                  <div className={`card-body ${item.active ? 'active' : ''}`}>
                    <span className="year-label">{item.years}</span>
                    <h5 className="m-0">{item.title}</h5>
                  </div>
                  <div className="card-arrow down"></div>
                </div>
              )}

              <div className="marker-dot-vps">
                <div className="inner-dot"></div>
              </div>

              {item.position === 'bottom' && (
                <div className="history-card bottom-card">
                  <div className="card-arrow up"></div>
                  <div className={`card-body ${item.active ? 'active' : ''}`}>
                    <span className="year-label">{item.years}</span>
                    <h5 className="m-0">{item.title}</h5>
                  </div>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </div>
</section>
     
    </div>
  );
};

export default About;